import { render, staticRenderFns } from "./LessonDetails.vue?vue&type=template&id=24c00603&"
import script from "./LessonDetails.vue?vue&type=script&lang=js&"
export * from "./LessonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports